import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-delivery-medium",
  "use": "icon-icon-delivery-medium-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-delivery-medium\">\n    <title>icons/icon-delivery-medium</title>\n    <g id=\"icon-icon-delivery-medium_icons/icon-delivery-medium\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <circle id=\"icon-icon-delivery-medium_Oval\" fill=\"#FFC46E\" cx=\"12\" cy=\"12\" r=\"4\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol